export const invalid  = '#f44336';
export const warning = '#f27000';
export const disabled = '#c1c1c1'